import { Uint8ArrayWriter, ZipWriter } from '@zip.js/zip.js';
/**
 * This method will zip a file collection and return the zip as an ArrayBuffer
 * @param collection - The file collection to zip
 * @returns Zip as an Uint8Array
 */
export async function toZip(collection) {
    const zipWriter = new ZipWriter(new Uint8ArrayWriter());
    const pathUsed = new Set();
    await Promise.all(collection.sources.map(async (source) => {
        const baseUrl = new URL(source.baseURL || 'ium:/');
        let path = `${baseUrl.pathname}/${source.relativePath}`.replaceAll(/\/\/+/g, '/');
        if (pathUsed.has(path)) {
            path = `${source.uuid}/${path}`.replaceAll(/\/\/+/g, '/');
        }
        else {
            pathUsed.add(path);
        }
        await zipWriter.add(path, source.stream());
    }));
    return await zipWriter.close();
}
//# sourceMappingURL=to_zip.js.map